import type { ProfilePatch } from '@xox/shared'
import { create } from 'zustand'
import { api, type Me } from '../lib/api'
import { feedback } from '../lib/feedback'

interface SessionState {
  me: Me | null
  loading: boolean
  error: string | null
  /** The level just reached, until the notice is dismissed. */
  levelUp: number | null
  load: () => Promise<Me | null>
  setProfile: (patch: ProfilePatch) => Promise<void>
  /** After a device transfer: this browser is somebody else now. */
  replace: (me: Me) => void
  dismissLevelUp: () => void
}

export const useSession = create<SessionState>((set, get) => ({
  me: null,
  loading: false,
  error: null,
  levelUp: null,
  async load() {
    if (get().loading) return get().me
    set({ loading: true, error: null })
    try {
      const me = await api.me()
      const prev = get().me
      const levelled =
        prev && prev.playerId === me.playerId && me.progress.level > prev.progress.level
      if (levelled) feedback('levelUp')
      set({ me, loading: false, ...(levelled ? { levelUp: me.progress.level } : {}) })
      return me
    } catch (err) {
      set({ loading: false, error: (err as Error).message })
      return null
    }
  },
  async setProfile(patch) {
    set({ me: await api.updateProfile(patch) })
  },
  replace(me) {
    set({ me, levelUp: null })
  },
  dismissLevelUp() {
    set({ levelUp: null })
  },
}))
